import React, { useEffect, useMemo, useState } from "react";
import success from "../../../assets/restaurant/images/success.png";
import { detail } from "../services/order.service";
import { getPersistentSessionKey } from "../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { ORDER_PLATFORM, SWAL_SETTINGS } from "../../../utils/Constants";
import { postAppMessage, postQrNativeMessage, QR_NATIVE_ACTIONS } from "../utils/nativeBridge";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function OrderSuccess() {
  const queryParams = new URLSearchParams(window.location.search);
  const order_id = queryParams.get("order_id");
  const [orderDetail, setOrderDetail] = useState(null);
  const [token, setToken] = useState(getPersistentSessionKey("qr_user_token"));
  const base = queryParams.get("base");
  const { t , i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    detail({ o_id: order_id }, { token: token })
      .then((response) => {
        setOrderDetail(response?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [order_id]);


  // The waiter native app owns the actual reprint (it knows the table id from its
  // own route params); this just relays the request over the WebView bridge, the
  // same way the native side's "reprint" listener already expects.
  const printKitchenReceiptData = () => {
    postQrNativeMessage(base, QR_NATIVE_ACTIONS.REPRINT, { type: "all" });
  };

  const handleAddMore = async () => {
    try {
      const latestToken = getPersistentSessionKey("qr_user_token") || token;
      const response = await detail(
        { o_id: order_id },
        { token: latestToken }
      );

      if (response?.success !== true) {
        void Swal.fire({
          icon: "warning",
          text: t("try_again"),
          ...SWAL_SETTINGS,
        });
        return;
      }

      const latestOrderDetail = response?.data;
      if (latestOrderDetail?.can_add_items === false) {
        void Swal.fire({
          icon: "warning",
          text: t("msg_split_payment_already_in_progress"),
          ...SWAL_SETTINGS,
        });
        return;
      }

      const mySearchParams = new URLSearchParams(window.location.search);
      mySearchParams.set(
        "order_id",
        latestOrderDetail?.parent_id ||
          latestOrderDetail?._id ||
          orderDetail?.parent_id ||
          order_id
      );
      navigate(
        {
          pathname: "/qr-order",
          search: mySearchParams.toString(),
        },
        {
          state: {
            customerDetails:
              latestOrderDetail?.customerDetails || orderDetail?.customerDetails,
          },
        }
      );
    } catch (err) {
      console.error(err);
      await Swal.fire({
        icon: "error",
        text: err?.response?.data?.message || t("try_again"),
        ...SWAL_SETTINGS,
      });
    }
  };
  return (
    <>
      <div className="qr-body-wrap">
        <div className="order-success-wrap">
          <article>
            <figure>
              <img src={success} />
            </figure>
            <figcaption>
              <span className="label_order_id">
                {t("label_order_no")} #{orderDetail?.order_id}
              </span>
              <h4>{base === ORDER_PLATFORM.WEB ? t("label_thanks_visiting") : t('order_placed')}</h4>
              {base === ORDER_PLATFORM.WEB && <p>{t("label_go_cashier")}</p>}
            </figcaption>
            {base !== ORDER_PLATFORM.WEB && (
              <>
                <div className=" p-3 d-flex flex-column justify-content-center align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      const appData = { action: "go-to", data: "HomePage" };
                      postAppMessage(appData);
                    }}
                    style={{ width:'198px'}}
                  >
                    {t('back_home')}
                  </button>

                  <button
                    className="btn btn-primary my-2"
                    onClick={handleAddMore}
                    style={{ width:'198px'}}
                  >
                    {t('label_add_more')}
                  </button>
               
                  <button
                    className="btn  btn-primary bg-white "
                    style={{ border: "1px solid #f8821b", color: "#f8821b", padding: "10px", width:'198px' }}
                    onClick={() => {
                      printKitchenReceiptData()
                    }}
                  >
                   {t('label_reprint')}
                  </button>
                </div>
              </>
            )}
          </article>
        </div>
      </div>
    </>
  );
}
